import { render } from "./BillingShopifyReturn.vue?vue&type=template&id=79cc89fe&scoped=true"
import script from "./BillingShopifyReturn.vue?vue&type=script&lang=ts"
export * from "./BillingShopifyReturn.vue?vue&type=script&lang=ts"

import "./BillingShopifyReturn.vue?vue&type=style&index=0&id=79cc89fe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-79cc89fe"

export default script